import axios from 'axios'
import ServiceBase from './ServiceBase'

class ImService extends ServiceBase {
  async queryMyMessages(params: {
    topicId: number
    linkType:string,
    link:string,
    page: number
    size: number
    beforeSequence: number
    afterSequence: number
    knownMessageIds?: number[]
  }) {
    const knownMessageIds = params.knownMessageIds?.length ? `&knownMessageIds=${encodeURIComponent(params.knownMessageIds.join(','))}` : ''
    const url = `account/im/queryMyMessages&topicId=${params.topicId}&page=${params.page}&size=${params.size}&beforeSequence=${params.beforeSequence}&afterSequence=${params.afterSequence}&linkType=${params.linkType}&link=${params.link}${knownMessageIds}`
    return new Promise((resolve, reject) => {
      this.webGet(
        null,
        (res) => {
          resolve(res)
        },
        url,
        (err) => {
          reject(err)
        }
      )
    })
  }

  async send(params: {
    topicId: number
    toDomain: string
    toId?: string
    contentType: string
    content: string
    loaded: boolean
  }) {
    const url = `account/im/send`
    return new Promise((resolve, reject) => {
      this.webPost(
        {
          params: JSON.stringify(params)
        },
        (res) => {
          if(res.success==true){
            resolve(res)
          }
          else {
            reject('server error')
          }
          
        },
        url,
        (err) => {
          reject(err)
        }
      )
    })
  }

  async topicByLink(type, link) {
    const url = `account/im/topicByLink&type=${type}&link=${link}`
    return new Promise((resolve, reject) => {
      this.webGet(
        {},
        (res) => {
          resolve(res)
        },
        url,
        (err) => {
          reject(err)
        }
      )
    })
  }

  async createTopic(params: { linkType: string; link: string; title: string }) {
    const url = `account/im/createTopic`
    return new Promise((resolve, reject) => {
      this.webPost(
        { params: params },
        (res) => {
          resolve(res)
        },
        url,
        (err) => {
          reject(err)
        }
      )
    })
  }

  async createTopicIfNotExistByLink(linkType: string, link: string, title?: string) {
    const topic: any = await this.topicByLink(linkType, link)
    if (topic.id != null) {
      return topic
    }
    await this.createTopic({
      linkType,
      link,
      title
    })
    const newTopic = await this.topicByLink(linkType, link)
    return newTopic
  }

  async markRead(ids) {
    const url = `account/im/markRead`
    return new Promise((resolve, reject) => {
      this.webPost(
        {
          params: JSON.stringify(ids)
        },
        (res) => {
          resolve(res)
        },
        url,
        (err) => {
          reject(err)
        }
      )
    })
  }

  // async findMyTopicByLink(params: { type: string; link: string }) {}

  async uploadFile(file, listId, uploadDir) {
    const formData = new FormData()
    const uploadUrl = `https://data.triptogo.com/index.php?route=tool/upload/upload_img&list_id=${listId}&uploaddir=${uploadDir}&return=json`
    formData.append('file', file)
    const resp = axios.post(uploadUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return (await resp).data
  }
}

export default new ImService()
